// Customers API endpoints

import apiClient from './client';

export const customersAPI = {
  /**
   * Autocomplete search for cash customer names
   * @param {Object} params - { customer: "XXX" }
   * @returns {Promise} Array of matching customers with id, customer, last_sale
   */
  autofill: (params) => apiClient.get('/customers/autofill', { params })
};
